import React, { useEffect, useState } from 'react';

import { Props } from './Header.types';
import styles from './Header.module.scss';
import { Button, Modal } from 'modules/af_cm_ui_kit/components';
import CreateNewAffordabilityForm from '../CreateNewAffordabilityForm/CreateNewAffordabilityForm';
import { runRequest } from 'utils/store/localItemsStore';
import { createCalculation } from 'modules/af_tool/api';
import { CreateNewAffordabilityFormValues } from '../types';
import mapper from '../utils/mapper';
import { CreateCalculationResponse } from 'modules/af_tool/api/types';
import apiClient from 'apiClient';

const Header: React.FC<Props> = ({ localStore, onCreateNewAffordability }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [refreshingProducts, setRefreshingProducts] = useState<boolean>(false);
  const [state, stateDispatch] = localStore;

  const handleSubmit = (formValues: CreateNewAffordabilityFormValues) => {
    runRequest<CreateCalculationResponse>(stateDispatch)(() => createCalculation(mapper(formValues)));
  };

  const handleRefreshProducts = async () => {
    setRefreshingProducts(true);
    await apiClient.get('/api/v1/af-tool/refresh-products').catch((err) => setRefreshingProducts(false));
    setRefreshingProducts(false);
  };

  useEffect(() => {
    if (state.loaded) {
      setIsOpen(false);
      onCreateNewAffordability(state.data);
    }
  }, [state, onCreateNewAffordability]);

  return (
    <div className={styles.wrapper}>
      <div>
        <h1>Affordability</h1>
        <h5>Update existing information or create a new calculation</h5>
      </div>
      <div className={styles.buttons}>
        <Button onClick={() => handleRefreshProducts()} disabled={refreshingProducts}>
          Refresh Products
        </Button>
        <Button className={styles.createbtn} mode="secondary" onClick={() => setIsOpen(true)}>
          Create new
        </Button>
      </div>
      <Modal title="New calculation" isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <CreateNewAffordabilityForm onSubmit={handleSubmit} />
      </Modal>
      <Modal isAutomated isOpen={refreshingProducts} title="Refreshing the product cache.." onClose={() => {}} />
    </div>
  );
};

export default Header;
